import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Status from "../header/Status";
import PdfLinkActions from "src/components/PdfLinkActions";

export default function InternalWorkOrderHeader({ internalWorkOrder, changeStatus }) {
  const internalWorkOrderNumberDisplay = useMemo(() => {
    const num = internalWorkOrder?.internalWorkOrderNumber;
    const rev = internalWorkOrder?.revisionNumber;
    if (!num) return "";
    return rev && rev > 0 ? `${num}.R${rev}` : num;
  }, [internalWorkOrder?.internalWorkOrderNumber, internalWorkOrder?.revisionNumber]);

  const statusInventoryRequest = useMemo(
    () => ({
      ...internalWorkOrder,
      warehousesFromInventoryItems: internalWorkOrder?.warehouse
        ? [internalWorkOrder.warehouse]
        : [],
    }),
    [internalWorkOrder]
  );

  return (
    <>
      <Box
        mb={2}
        display="flex"
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        flexDirection={{ xs: "column", sm: "row" }}
        gap={1}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Typography color="textPrimary" fontSize={18} fontWeight={500}>
            {internalWorkOrderNumberDisplay}
          </Typography>
          <PdfLinkActions
            resourceType="internal_work_order_pdfs"
            resourceId={internalWorkOrder?.id}
          />
        </Box>
        {internalWorkOrder.project.name && (
          <Typography color="textPrimary" fontSize={18} fontWeight={500}>
            {internalWorkOrder.project.name}
          </Typography>
        )}
      </Box>
      <Box mb={3}>
        <Status
          loading={false}
          disabled={false}
          inventoryRequest={statusInventoryRequest}
          changeStatus={changeStatus}
          orderType="internalWorkOrder"
        />
      </Box>
    </>
  );
}
